import { env } from '@/common/constants/env';

/**
 * localStorage keys of Zustand stores deleted by the RTK Query migration. Stopping
 * the writes is not enough: patient and anamnesis data written before the migration
 * would otherwise sit in localStorage forever (HDS concern). Remove this once every
 * active browser has run a post-migration build.
 */
const LEGACY_STORAGE_KEYS = [
  'patient-storage',
  'anamnesis-storage',
  'media-storage',
  'notification-storage',
  'admin-user-storage',
  'evaluation-storage',
  `feedback-${env.APP_SLUG}`,
  `institutions-${env.APP_SLUG}`,
  `device-management-${env.APP_SLUG}`,
  `agent-${env.APP_SLUG}`,
];

export const purgeLegacyStorage = (): void => {
  for (const key of LEGACY_STORAGE_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      // Storage can be unavailable (privacy mode); nothing to purge then.
    }
  }
};
